import React from "react";

const FormSection = ({ title, level = 1, children, button = null }) => {
    const Tag = `h${Math.min(6, level + 3)}`; // level=1 -> h4
    return (
        <section className="mb-4 form-section">
            <Tag className={`text-muted ${level === 1 ? "fw-semibold" : "fw-medium"}`}>
                {title} {button}
            </Tag>
            {children}
        </section>
    );
};

export default FormSection;